module.exports = __webpack_public_path__ + "img/conny-stage7-sulking.50c639bc.png";